import React, { useEffect, useState } from 'react';
import { Dialog, DialogTitle, DialogContent, Typography, IconButton, Box, CircularProgress } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import { CupomWrapper, CashbackText, TitleTypography, StoreAvatar, CouponCodeBox, CupomBox, LinkTypography, CouponButton } from './Styled';
import useCopyCoupon from '../../../hooks/useCopyCoupon';
import useSendCouponFeedback from '../../../hooks/useSendCouponFeedback';
import { useAlert } from '../../../context/AlertContext';
import CupomFeedbackForm from './CupomFeedbackForm';
import { STORE_IMAGES } from '../../../constants/urls';
import { pushData, pushEvent } from '../../../utils/dataLayer';
import { formatCashback } from '../../Coupons/CouponCard';

export default function CupomModal({ open, handleClose, name, cupomLink, cupomCode, description, endDate, storeSlug, storeName, cashback, clicks, couponId, incentiveId, userId }) {
    const formattedEndDate = endDate ? new Date(endDate).toLocaleDateString('pt-BR') : '';
    const storeImageUrl = `${STORE_IMAGES}${storeSlug}.png`;
    const formattedCashback = cashback ? `${formatCashback(cashback)} DE CASHBACK` : null;

    const { copyAndRedirect, loading: loadingRedirect } = useCopyCoupon({ cupomLink, couponId, storeSlug, incentiveId, userId });
    const { sendCouponFeedback, loading, error, response } = useSendCouponFeedback();
    const { showAlert } = useAlert();
    const [showForm, setShowForm] = useState(false);
    const [formData, setFormData] = useState({ nome: '', email: '', mensagem: '' });

    useEffect(() => {
        if (!open) return;
        pushData({
            coupon: { id: couponId, name, description, endDate, clicks, incentiveId },
            store: { slug: storeSlug, name: storeName },
        });
        pushEvent('lightbox-coupon-show');
    }, [open, couponId]);

    useEffect(() => {
        if (response) {
        pushEvent('coupon.dislike.submited', { couponId });
        showAlert(response, 'success');
        setFormData({ nome: '', email: '', mensagem: '' });
        }
        if (error) showAlert(error, 'error');
    }, [response, error]);

    const handleChange = (e) => setFormData({ ...formData, [e.target.name]: e.target.value });
    const handleSubmit = (e) => {
        e.preventDefault();
        sendCouponFeedback({ couponId, name: formData.nome, email: formData.email, message: formData.mensagem });
    };

    return (
        <Dialog open={open} onClose={handleClose} maxWidth="sm" fullWidth
        slotProps={{paper: {
            sx: {
                borderRadius: '20px',
                position: 'relative',
                paddingRight: '12px',
                '&::before': {
                content: '""',
                position: 'absolute',
                top: 0,
                right: 0,
                width: {
                    xs: '10px',
                    sm: '20px',
                },
                height: '100%',
                backgroundColor: 'var(--c-brand-link)',
                },
            },
            },
        }}
        >
        <DialogTitle sx={{ display: 'flex', justifyContent: 'space-between' }}>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                <Typography variant="caption">{clicks} visualizações</Typography>
                {formattedEndDate && (
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                    <AccessTimeIcon fontSize="small" />
                    <Typography variant="caption">Expira: {formattedEndDate}</Typography>
                    </Box>
                )}
            </Box>
            <IconButton onClick={handleClose}><CloseIcon /></IconButton>
        </DialogTitle>

        <DialogContent sx={{ display: 'flex', flexDirection: 'column', gap: 2, textAlign: 'center', maxHeight: '70vh', overflowY: 'auto',}}>
            <TitleTypography>{name}</TitleTypography>

            <CupomBox>
                <StoreAvatar src={storeImageUrl} alt={storeName} />
                <CashbackText>{formattedCashback}</CashbackText>
            </CupomBox>

            <Typography variant="caption">
            Copie e cole o Código no carrinho de compras do site {storeName}
            </Typography>

            <CupomWrapper id="pegadordecodigo" className="botao-cupom click-redirect" >
                {cupomCode && <CouponCodeBox id="couponCodeInput" value={cupomCode} readOnly />}
                
                <CouponButton
                variant="contained"
                color="primary"
                onClick={() => copyAndRedirect(cupomCode, handleClose)}
                disabled={loadingRedirect}
                >
                {loadingRedirect ? (
                    <CircularProgress size={20} color="inherit" />
                ) : (
                    cupomCode ? 'Copiar código e ir para a loja' : 'Ir para a loja'
                )}
                </CouponButton>
            </CupomWrapper>

            <Typography variant="caption" sx={{ mt: 2 }}>{description}</Typography>

            <LinkTypography onClick={() => setShowForm(!showForm)}>
            {showForm ? 'Ocultar formulário de contato' : 'Reportar problema com o desconto.'}
            </LinkTypography>

            {showForm && (
            <CupomFeedbackForm
                formData={formData}
                onChange={handleChange}
                onSubmit={handleSubmit}
                loading={loading}
            />
            )}
        </DialogContent>
        </Dialog>
    );
}